var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 23,
    viewBox: "0 0 42 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2481 0.536011L13.4721 15.576V23H8.00012V15.576L0.224121 0.536011H6.43212L10.7841 9.94401L15.1041 0.536011H21.2481Z",
    fill: "#191114"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9089 23L30.2369 14.52H28.9249V23H23.4529V0.536011H32.6369C34.4075 0.536011 35.9115 0.845344 37.1489 1.46401C38.4075 2.08268 39.3462 2.93601 39.9649 4.02401C40.5835 5.09068 40.8929 6.28534 40.8929 7.60801C40.8929 9.10134 40.4662 10.4347 39.6129 11.608C38.7809 12.7813 37.5435 13.6133 35.9009 14.104L41.0849 23H34.9089ZM28.9249 10.648H32.3169C33.3195 10.648 34.0662 10.4027 34.5569 9.91201C35.0689 9.42134 35.3249 8.72801 35.3249 7.83201C35.3249 6.97868 35.0689 6.30668 34.5569 5.81601C34.0662 5.32534 33.3195 5.08001 32.3169 5.08001H28.9249V10.648Z",
    fill: "#191114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYr);
export default __webpack_public_path__ + "static/media/YR.1c62eae2ed17aad31a16a7a656dd48ae.svg";
export { ForwardRef as ReactComponent };